export default "__VITE_ASSET__Bbez$Bzq__"